module.exports = __webpack_public_path__ + "static/media/covered-woman.9fb15a45.PNG";